import { NewBookingButton } from '@components/Common/NewBookingButton';
import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { NoddiLoadingScreenWithTrans } from '@components/Loading/NoddiLoadingScreenWithTrans';
import { InviteFriendsTeaser } from '@components/Referrals/InviteFriendsTeaser';
import { t } from '@lingui/core/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useParams } from 'react-router-dom';

export const FeedbackSuccess = () => {
  const { slug } = useParams();

  const {
    data: booking,
    isPending: isBookingPending,
    error: bookingError
  } = noddiAsync.useGet({
    type: URLKeys.getBookingInfo,
    input: { slug: slug! }
  });

  if (isBookingPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (bookingError) {
    return <ApiErrorPageWithTrans error={[bookingError]} />;
  }

  const title = t`Thank you for your feedback!`;
  return (
    <ContentWrapperCustomerApp hideBackButton className='flex flex-col gap-5'>
      <div className='flex flex-col gap-2 text-balance'>
        {/* eslint-disable-next-line noddi/no-emoji-in-ui -- deliberate emoji in customer-facing copy: it carries the tone of the message, it is not a status a NoddiIcon could show */}
        <h1 className='text-3xl font-bold text-primary md:text-4xl xl:text-5xl'>{title + ' 🎊'}</h1>
        <p className='text-lg'>{t`This helps us improve our service.`}</p>
      </div>

      <div className='flex flex-wrap gap-2'>
        <NoddiLink
          className='flex-1'
          variant='outline'
          to={customerRoutes.bookingInfo.getPath({ slug: booking.slug })}
        >{t`View booking`}</NoddiLink>
        <NewBookingButton className='flex-1' defaultSize />
      </div>
      <InviteFriendsTeaser />
    </ContentWrapperCustomerApp>
  );
};
